import { useState, useEffect, Fragment } from 'react';
export default function Sidebar({ current, open, onNavigate, onLogout, tenant, isAdmin, permisos }) {
  const items = [
    { id: 'overview',       icon: '⊞',  label: 'Overview',        libre: true,  group: null },
    // ── AGENTE ── (oculto entero si el plan no incluye web ni whatsapp, ej: presencia)
    { id: 'config',         icon: '🤖', label: 'Mi Agente',       libre: permisos?.web || permisos?.whatsapp, oculto: !permisos?.web && !permisos?.whatsapp, group: 'AGENTE' },
    { id: 'canales',        icon: '📡', label: 'Canales',         libre: !!permisos?.whatsapp, oculto: !permisos?.whatsapp, group: 'AGENTE' },
    { id: 'webhooks',       icon: '🌐', label: 'Widget Web',      libre: !!permisos?.web, oculto: !permisos?.web, group: 'AGENTE' },
    { id: 'conversaciones', icon: '◎',  label: 'Conversaciones',  libre: !!permisos?.conversaciones, oculto: !permisos?.conversaciones, group: 'AGENTE' },
    { id: 'calendario',     icon: '📅', label: 'Calendario',      libre: permisos?.web || permisos?.whatsapp, oculto: !permisos?.web && !permisos?.whatsapp, group: 'AGENTE' },
    // ── INMOBILIARIA ── (oculto si especialidad !== 'inmobiliaria', salvo admin)
    { id: 'propiedades',   icon: '🏠', label: 'Propiedades',      libre: tenant?.especialidad === 'inmobiliaria' || isAdmin, oculto: tenant?.especialidad !== 'inmobiliaria' && !isAdmin, group: 'INMOBILIARIA' },
    { id: 'cualificacion', icon: '✓',  label: 'Cualificación',    libre: (tenant?.especialidad === 'inmobiliaria' && !!permisos?.leads) || isAdmin, oculto: (tenant?.especialidad !== 'inmobiliaria' && !isAdmin) || (!permisos?.leads && !isAdmin), group: 'INMOBILIARIA' },
    { id: 'leads',         icon: '◉',  label: 'Leads',            libre: (tenant?.especialidad === 'inmobiliaria' && !!permisos?.leads) || isAdmin, oculto: (tenant?.especialidad !== 'inmobiliaria' && !isAdmin) || (!permisos?.leads && !isAdmin), group: 'INMOBILIARIA' },
    // ── RECLUTADOR ── (solo admin — módulo pausado por cumplimiento EU AI Act)
    { id: 'ofertas',       icon: '📋', label: 'Ofertas',          libre: isAdmin, oculto: !isAdmin, group: 'RECLUTADOR' },
    { id: 'candidatos',    icon: '👤', label: 'Candidatos',       libre: isAdmin, oculto: !isAdmin, group: 'RECLUTADOR' },
    // ── ECOMMERCE ── (oculto si especialidad no es 'ecommerce', salvo admin)
    { id: 'productos', icon: '🛍', label: 'Productos', libre: ['ecommerce','e-commerce','tienda','shop'].some(k => (tenant?.especialidad||'').toLowerCase().includes(k)) || isAdmin, oculto: !['ecommerce','e-commerce','tienda','shop'].some(k => (tenant?.especialidad||'').toLowerCase().includes(k)) && !isAdmin, group: 'ECOMMERCE' },
    // ── MARKETING ──
    { id: 'social',        icon: '📣', label: 'Publicador Social', libre: !!permisos?.social || isAdmin, oculto: !permisos?.social && !isAdmin, group: 'MARKETING' },
    { id: 'seo',           icon: '🔍', label: 'Presencia Google',  libre: !!permisos?.seo   || isAdmin, oculto: !permisos?.seo && !isAdmin, group: 'MARKETING' },
    { id: 'academia',      icon: '🎓', label: 'Formación EU AI Act', libre: true, group: 'MARKETING' },
    // ── CUENTA ──
    { id: 'tokens',  icon: '◈',  label: 'Uso de tokens',   libre: permisos?.tokens,  group: 'CUENTA' },
    { id: 'billing',       icon: '◇',  label: 'Suscripción',      libre: true, group: 'CUENTA' },
    ...(isAdmin ? [
    { id: 'admintickets',  icon: '🎫', label: 'Tickets',          libre: true, group: 'CUENTA' },
    { id: 'health',        icon: '◈',  label: 'Health Check',     libre: true, group: 'CUENTA' },
    ] : []),
    ...(!isAdmin ? [
    { id: 'soporte',       icon: '🎫', label: 'Soporte',          libre: true, group: 'CUENTA' },
    ] : []),
  ];
    // Añade al inicio del componente:
    const [darkMode, setDarkMode] = useState(() => {
      const saved = localStorage.getItem('devit_theme');
      if (saved) return saved === 'dark';
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });

    const toggleTheme = () => {
      const newDark = !darkMode;
      setDarkMode(newDark);
      localStorage.setItem('devit_theme', newDark ? 'dark' : 'light');
      document.documentElement.setAttribute('data-theme', newDark ? 'dark' : 'light');
    };

    // Aplicar tema al montar
  useEffect(() => {
  document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const initials = tenant?.nombre
    ? tenant.nombre.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase()
    : 'TA';

  return (
    <aside className={`sidebar${open ? ' open' : ''}`}>
      <div className="logo">
        <img src="/img/logo_blanco.png" alt="Devit Logo" class="logo-img"></img>
        <div className="logo-sub">automatización inteligente</div>
      </div>

      <nav className="nav">
        {(() => {
          let currentGroup = undefined;
          return items.filter(item => !item.oculto).map(item => {
            const showHeader = item.group !== currentGroup;
            currentGroup = item.group;
            return (
              <Fragment key={item.id}>
                {showHeader && item.group && (
                  <div style={{
                    padding: '10px 16px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}>
                    <span style={{
                      fontSize: '9px',
                      fontWeight: '700',
                      letterSpacing: '0.1em',
                      color: 'var(--text3, #888)',
                      textTransform: 'uppercase',
                      whiteSpace: 'nowrap',
                    }}>{item.group}</span>
                    <div style={{ flex: 1, height: '1px', background: 'var(--border, #333)' }} />
                  </div>
                )}
                <div
                  className={`nav-item ${current === item.id ? 'active' : ''} ${!item.libre ? 'locked' : ''}`}
                  //onClick={() => onNavigate(item.id)}
                  onClick={() => item.libre ? onNavigate(item.id) : onNavigate('billing')}
                  style={{ opacity: item.libre ? 1 : 0.5 }}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {item.label}
                  {item.id === 'tokens' && item.libre && <span className="nav-badge">!</span>}
                  {!item.libre && <span style={{ marginLeft: 'auto', fontSize: '11px' }}>🔒</span>}
                </div>
              </Fragment>
            );
          });
        })()}
        {isAdmin && (
          <div className={`nav-item ${current === 'admin' ? 'active' : ''}`} onClick={() => onNavigate('admin')}>
            <span className="nav-icon">◉</span> Admin
          </div>
        )}
        <div className="nav-item" style={{ marginTop: '8px', opacity: 0.6 }} onClick={onLogout}>
          <span className="nav-icon">→</span> Logout
        </div>
      </nav>

      <div className="sidebar-footer">
        <div className="tenant-pill">
          <div className="tenant-avatar">{initials}</div>
          <div>
            <div className="tenant-name">{tenant?.nombre || 'Mi Empresa'}</div>
            <div className="tenant-plan">{tenant?.plan || 'basic'} · {tenant?.activo ? 'activo' : 'inactivo'}</div>
          </div>
        </div>
      </div>
      <div style={{padding:'8px', borderTop:'1px solid var(--border)'}}>
  <button
    onClick={toggleTheme}
    style={{
      width:'100%', padding:'8px', borderRadius:'6px',
      background:'var(--bg3)', border:'1px solid var(--border)',
      color:'var(--text2)', cursor:'pointer', fontSize:'12px',
      display:'flex', alignItems:'center', justifyContent:'center', gap:'8px'
    }}
  >
    {darkMode ? '☀️ Modo claro' : '🌙 Modo oscuro'}
  </button>
</div>
    </aside>
  );
}
